// extracted by mini-css-extract-plugin
module.exports = {"container":"SyncCalendar_container__6wYM8","settingsBody":"SyncCalendar_settingsBody__2sjci","spin360":"SyncCalendar_spin360__1U17e"};